export const lumiere_sur_lart = {
  logo_image_url: 'lumiere-sur-lart/default.png',
  logo_height: 258,

  header_no_margin: true,

  number_font: `'Poppins', sans-serif`,
  number_weight: 600,

  body_background_color: 'black',

  button_color: 'black',
  button_radius: 15,
  button_half_border_color: 'black',

  text_font: `'Poppins', sans-serif`,
  text_size: 15,

  title_font: `'Poppins', sans-serif`,
  title_size: 34,
  title_lineheight: 38,
  title_weight: 600,

  subtitle_weight: 600,
}

export const pierre_et_marie = {
  logo_image_url: 'lumiere-sur-lart/pierre-et-marie.png',

  header_full_height: true,

  card_header_negative_margin: true,

  body_background_color: '#f1f1f1',

  button_color: '#234195',
  button_text_uppercase: true,
  button_radius: 30,
  button_half_border_color: '#234195',
  button_outlined_as_default: false,

  text_font: `'Futura', sans-serif`,
  title_font: `'Futura', sans-serif`,
  title_weight: 400,
}
